import { Injectable } from '@angular/core';
import { Filesystem, Directory, DownloadFileResult } from '@capacitor/filesystem';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { Browser } from '@capacitor/browser';
import { Device } from '@capacitor/device';
import { Share } from '@capacitor/share';
import { Mediastore } from '@cotecna/capacitor-mediastore';
import { Platform, ToastController } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';
import { AppPlatformService } from '../platform/app-platform.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadFileService {

  constructor(
    public platform: Platform,
		private toastCtrl: ToastController,
		private androidPermissions: AndroidPermissions,
    private appPlatformService:AppPlatformService,
  ) {

  }

   async downloadMediaInMobileDevice(url_media, subPath, enableShareFile = false) {
    //subPath === extension del archivo => video.mp4  pdf.mp4
    if(this.appPlatformService.isAppPlatform()) {
      if (this.platform.is("android") ) {
        this.presentDownloadingToast(`Descargando...`);
        let permission = await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE);
        if (permission.hasPermission) {
            console.log('Permission granted...');
            this.downloadFileWithPermission(url_media, subPath, enableShareFile);
        }
        else {
            console.log('Asking for Permission...');
            permission = await this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE);
            if (permission.hasPermission) {
              this.downloadFileWithPermission(url_media, subPath, enableShareFile);
            } else {
              const deviceInfo = await Device.getInfo();
              console.log("DEVICE INFO:: ",JSON.stringify(deviceInfo));
              if(parseInt(deviceInfo.osVersion) > 12) { this.downloadFileWithPermission(url_media, subPath, enableShareFile); }
            };
        };

      };

      if (this.platform.is("ios")) {
        this.presentToast("Descargando...", 2000);
        Filesystem.downloadFile({ url: url_media, path: subPath, directory: Directory.Documents }).then(response => {
          this.presentToast(`Descargado`, 5000);
          console.log('Descargado', JSON.stringify(response));
        }).catch(err => {
          console.log('error block ... ', err);
          this.presentToast("Algo salió mal: " + err, 5000);
        });

      };
    }
	}

  downloadMultipleMediaInMobileDevice(url_media, subPath, enableShareFile = false): Promise<void> {
    return new Promise(async (resolve, reject) => {
      if(this.appPlatformService.isAppPlatform()) {
        if (this.platform.is("android") ) {
          this.presentDownloadingToast(`Descargando test...`);
          try {
            let permission = await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE);
            if (!permission.hasPermission) {
              console.log('Asking for Permission...');
              permission = await this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE);
            }

            const deviceInfo = await Device.getInfo();
            if (permission.hasPermission || parseInt(deviceInfo.osVersion) > 12) {
              console.log('Permission granted...');
              await this.downloadMultipleFileWithPermission(url_media, subPath, enableShareFile);
              resolve();
            } else {
              console.log('Permission denied...');
              reject('Permission denied');
            }
          } catch (error) {
            console.error('Error handling permissions or download', error);
            reject(error);
          }
        };

        if (this.platform.is("ios")) {
          this.presentToast("Descargando...", 2000);
          Filesystem.downloadFile({ url: url_media, path: subPath, directory: Directory.Documents }).then(response => {
            this.presentToast(`Descargado`, 5000);
            console.log('Descargado', JSON.stringify(response));
            resolve();
          }).catch(err => {
            console.log('error block ... ', err);
            this.presentToast("Algo salió mal: " + err, 5000);
            reject(err);
          });
        };
      } else {
        resolve();
      }
    });
	}

  async downloadMediaWithBrowser(url, forceWebDocDownload?) {
    if(this.appPlatformService.isAppPlatform()) {
      await Browser.open({ url: url });
    } else {
      if(forceWebDocDownload) {
        this.forceDocDownload(url, forceWebDocDownload.fileName)
      } else {
        window.open(url, "_system");
      }
    }
  }

  forceDocDownload(docDownloadUrl, fileName) {
    fetch(docDownloadUrl)
    .then(response => response.blob())  // Convertir la respuesta en un Blob
    .then(blob => {
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName; //'archivo.pdf' Nombre del archivo
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl); // Liberar memoria
    })
    .catch(error => console.error('Error al descargar el archivo', error));
  }

  async downloadFileWithPermission(url_media, mediaPath, enableShareFile ) {
    console.log("downloadFileWithPermission:: ", url_media, mediaPath);
    const deviceInfo = await Device.getInfo();

    Filesystem.downloadFile({
      path: mediaPath,
      url: url_media,
      directory: Directory.Documents,
    })
    .then((res: DownloadFileResult) => {
      // console.log("2 downloadFileWithPermission:: ",res)
      this.closeDownloadingToast();
      setTimeout(async () => {
            const uriRes =  await Filesystem.getUri({
              directory: Directory.Documents,
              path: mediaPath,
            });

            if(parseInt(deviceInfo.osVersion) > 10) {
              let res2 = await Mediastore.saveToDownloads({
                filename: mediaPath,
                path: decodeURIComponent(uriRes.uri)
              });
              // console.log("3 mediatore res::", JSON.stringify(res2));
              this.presentToast("Descarga completada", 3000);
            } else{
               //el usuario elige donde guardar
              if(enableShareFile) {
                await Share.share({ url: uriRes.uri });
              } else {
                this.presentToast("Descargado en: " + res.path.split("/").slice(-2).join('/'), 5000);
              }
            }
      }, 100);
    })
    .catch(error => {
      	this.closeDownloadingToast();
				setTimeout(() => {
					this.presentToast("Error: " + JSON.stringify(error), 5000);
				}, 300);
        console.log(error)
    });
	}
  async downloadMultipleFileWithPermission(url_media, mediaPath, enableShareFile ) {
    console.log("1 downloadFileWithPermission:: ", url_media, mediaPath);
    const deviceInfo = await Device.getInfo();

    try {
      const res = await Filesystem.downloadFile({
        path: mediaPath,
        url: url_media,
        directory: Directory.Documents,
      });
      console.log("2 downloadFileWithPermission:: ",res)
      this.closeDownloadingToast();
      // setTimeout(async () => {
            const uriRes =  await Filesystem.getUri({
              directory: Directory.Documents,
              path: mediaPath,
            });

            if(parseInt(deviceInfo.osVersion) > 10) {
              let res2 = await Mediastore.saveToDownloads({
                filename: mediaPath,
                path: decodeURIComponent(uriRes.uri)
              });
              console.log("3 mediatore res::", JSON.stringify(res2));
              this.presentToast("Descarga completada", 3000);
            } else{
               //el usuario elige donde guardar
              if(enableShareFile) {
                await Share.share({ url: uriRes.uri });
              } else {
                this.presentToast("Descargado en: " + res.path.split("/").slice(-2).join('/'), 5000);
              }
            }
      // }, 100);
    } catch (error) {
      this.closeDownloadingToast();
      setTimeout(() => {
        this.presentToast("Error: " + JSON.stringify(error), 5000);
      }, 300);
      console.log(error)
    }

	}

  async presentToast(msg, duration) {
		const toast = await this.toastCtrl.create({
			message: msg,
			duration: duration,
		});
		toast.present();
	}

	async presentDownloadingToast(msg) {
		const toast = await this.toastCtrl.create({
			message: msg,
       id: 'downloading-toast'
		});
		toast.present();
	}

	closeDownloadingToast() {
    try {
      this.toastCtrl.dismiss();
      this.toastCtrl.dismiss(null, null, 'downloading-toast');
    } catch (error) {
      this.toastCtrl.dismiss();

    }
    console.log("closeDownloadingToast!!")
	}

  async downloadSignedFileInMobileDevice(url_media, subPath, enableShareFile = false) {
    //subPath === extension del archivo => video.mp4  pdf.mp4
    if(this.appPlatformService.isAppPlatform()) {
      if (this.platform.is("android") ) {
        this.presentDownloadingToast(`Descargando...`);
        let permission = await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE);
        if (permission.hasPermission) {
            console.log('Permission granted...');
            this.downloadFileWithPermission(url_media, subPath, enableShareFile);
        }
        else {
            console.log('Asking for Permission...');
            permission = await this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE);
            if (permission.hasPermission) {
              this.downloadFileWithPermission(url_media, subPath, enableShareFile);
            } else {
              const deviceInfo = await Device.getInfo();
              console.log("DEVICE INFO:: ",JSON.stringify(deviceInfo));
              if(parseInt(deviceInfo.osVersion) > 12) { this.downloadFileWithPermission(url_media, subPath, enableShareFile); }
            };
        };

      };

      if (this.platform.is("ios")) {
        this.presentToast("Descargando...", 2000);
        Filesystem.downloadFile({ url: url_media, path: subPath, directory: Directory.Documents }).then(response => {
          this.presentToast(`Descargado`, 5000);
          console.log('Descargado', JSON.stringify(response));
        }).catch(err => {
          console.log('error block ... ', err);
          this.presentToast("Algo salió mal: " + err, 5000);
        });

      };
    }
	}

  // --- Authenticated file download (with Bearer token) ---
  public sanitizeFileName(name: string): string {
    return name.replace(/[:\\*\\?"<>|]/g, '_').replace(/\s+/g, '_');
  }

  /**
   * Con `throwOnError`, una descarga fallida se rechaza con un {@link AuthenticatedDownloadError}
   * (en web, con el `message` del backend si lo trae) para que quien llama lo muestre. En la app,
   * `Filesystem.downloadFile` rechaza las respuestas que no son 2xx (iOS por el código, Android porque
   * `HttpURLConnection.inputStream` lanza): ese rechazo llega sin el cuerpo, así que va con status 0.
   * Sin la opción, sigue como siempre: el error va a la consola o a un toast propio.
   */
  async downloadAuthenticatedFile(url: string, fileName: string, token: string, options: { throwOnError?: boolean } = {}) {

    const headers = {
      'Authorization': `Bearer ${token}`,
      'Accept': 'application/octet-stream',
    };

    if (this.appPlatformService.isAppPlatform()) {
      if (this.platform.is("android")) {
        this.presentDownloadingToast(`Descargando...`);
        await this.downloadAuthenticatedFileAndroid(url, fileName, headers, !!options.throwOnError);
      }
      if (this.platform.is("ios")) {
        this.presentToast("Descargando...", 2000);
        await this.downloadAuthenticatedFileIos(url, fileName, headers, !!options.throwOnError);
      }
    } else {
      await this.downloadAuthenticatedFileWeb(url, fileName, headers, !!options.throwOnError);
    }
  }

  private async downloadAuthenticatedFileWeb(url: string, fileName: string, headers: Record<string, string>, throwOnError = false) {
    try {
      const response = await fetch(url, { headers });
      if (!response.ok) {
        throw new AuthenticatedDownloadError(response.status, await this.backendMessage(response));
      }
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error downloading authenticated file (web):', error);
      if (throwOnError) {
        throw error instanceof AuthenticatedDownloadError ? error : new AuthenticatedDownloadError(0, null);
      }
    }
  }

  /** El `message` del cuerpo JSON de un error, si lo hay. */
  private async backendMessage(response: Response): Promise<string | null> {
    try {
      const body = await response.json();
      return body && typeof body.message === 'string' && body.message ? body.message : null;
    } catch {
      return null;
    }
  }

  private async downloadAuthenticatedFileAndroid(url: string, fileName: string, headers: Record<string, string>, throwOnError = false) {
    try {
      let permission = await this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE);
      if (!permission.hasPermission) {
        permission = await this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE);
      }
      const deviceInfo = await Device.getInfo();
      if (permission.hasPermission || parseInt(deviceInfo.osVersion) > 12) {

        const res = await Filesystem.downloadFile({
          path: fileName,
          url: url,
          directory: Directory.Documents,
          headers: headers,
        });


        this.closeDownloadingToast();
        const uriRes = await Filesystem.getUri({
          directory: Directory.Documents,
          path: fileName,
        });

        if (parseInt(deviceInfo.osVersion) > 10) {
          await Mediastore.saveToDownloads({
            filename: fileName,
            path: decodeURIComponent(uriRes.uri),
          });
          this.presentToast("Descarga completada", 3000);
        } else {
          this.presentToast("Descargado en: " + res.path.split("/").slice(-2).join('/'), 5000);
        }
      } else if (throwOnError) {
        // sin permiso de escritura no se baja nada: que quien llama no lo dé por descargado
        throw new Error('WRITE_EXTERNAL_STORAGE denied');
      }
    } catch (error) {
      this.closeDownloadingToast();
      console.error('Error downloading authenticated file (android):', error);
      if (throwOnError) {
        throw new AuthenticatedDownloadError(this.nativeErrorStatus(error), null);
      }
      setTimeout(() => {
        this.presentToast("Error: " + JSON.stringify(error), 5000);
      }, 300);
    }
  }

  private async downloadAuthenticatedFileIos(url: string, fileName: string, headers: Record<string, string>, throwOnError = false) {
    try {
      const res = await Filesystem.downloadFile({ url, path: fileName, directory: Directory.Documents, headers });
      if (!res || !res.path) throw new Error('Download without a file');
      this.presentToast(`Descargado`, 5000);
    } catch (err) {
      console.error('Error downloading authenticated file (ios):', err);
      if (throwOnError) {
        throw new AuthenticatedDownloadError(this.nativeErrorStatus(err), null);
      }
      this.presentToast("Algo salió mal: " + err, 5000);
    }
  }

  /** El plugin nativo no expone el código HTTP; si algún día lo trae (`status`), se usa. */
  private nativeErrorStatus(error: any): number {
    const status = Number(error && (error.status || (error.data && error.data.status)));
    return isNaN(status) ? 0 : status;
  }

}

/** Descarga autenticada fallida en web (`status` 0 = no hubo respuesta). */
export class AuthenticatedDownloadError extends Error {
  constructor(public readonly status: number, public readonly backendMessage: string | null) {
    super(backendMessage || `HTTP ${status}`);
    this.name = 'AuthenticatedDownloadError';
  }
}
